import {Button} from "@mui/material";
import {useAuth} from "../Auth/AuthPage.jsx";

const EditVenueButton = (props) => {
    const documentId = props.venue?.documentId || "new";
    const {loggedIn} = useAuth()

    if (!loggedIn) {
        return <span />
    }
    return <Button size={"small"} href={"/venue/edit/" + documentId}>{documentId === "new" ? "Add" : "Edit"} Venue</Button>
}

export default EditVenueButton